import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import MyAccountCommonize from './MyAccountCommonize';
import useStateRef from 'react-usestateref';
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction'
import { useDispatch, useSelector } from 'react-redux';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { Modal } from '../Modal/Modal';
import CbMobileLogOut from './CbMobileLogOut';
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';

function OrderHistory({ containerObject, templateName, contentId, dataZone }) {
    const [orderHitstoryList, setOrderHitstoryList, orderHitstoryListRef] = useStateRef('');
    const [orderItemId, setOrderItemId, orderItemIdRef] = useStateRef('');
    const [orderItemDetail, setOderItemDetail, orderItemDetailRef] = useStateRef('');
    const [cartModal, setCartModal] = useState(false);
    const [itemTotalCount, setItemTotalCount, itemTotalCountRef] = useStateRef('');
    const [paginationNumber, setPaginationNumber, paginationNumberRef] = useStateRef('');
    const [cartUpdatedModal, setCartUpdatedModal] = useState(false);
    const [currentPageCount, setCurrentPageCount, currentPageCountRef] = useStateRef(1);
    const [itemSortName, setItemSortName, itemSortNameRef] = useStateRef('jdeOrderNumber');
    const [accendFlag, setAccendFlag, accendFlagRef] = useStateRef(false);
    const [resultPerPage, setResultPerPage, resultPerPageRef] = useStateRef("12");
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [profileId, setProfileId, profileIdRef] = useStateRef('');
    const [completeOrderHistoryUrl, setCompleteOrderHistoryUrl, completeOrderHistoryUrlRef] = useStateRef('')
    const [b2cBillingAddress, setB2cBillingAddress, b2cBillingAddressRef] = useStateRef('');
    const [sortFlag, setSortFlag, sortFlagRef] = useStateRef(false);
    const [submittedDateFlag, setSubmittedDateFlag, submittedDateRef] = useStateRef(false);
    const [jdeOrderNumberFlag, setJdeOrderNumberFlag, jdeOrderNumberRef] = useStateRef(false);
    const [errorMsg, setErrorMsg, errorMsgRef] = useStateRef('');
    const [orderPlusLinkMsg, setOrderPlusLinkMsg, orderPlusLinkMsgRef] = useStateRef('');
    const [showCompleteOrderHistory, setShowCompleteOrderHistory, showCompleteOrderHistoryRef] = useStateRef(false)
    const [userType, setUserType, userTypeRef] = useStateRef('')
    const dispatch = useDispatch();
    const history = useHistory();
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    useEffect(() => {

        if (profileDetails && !profileDetails?.transient && profileDetails?.userType) {
            setUserType(profileDetails.userType)
        } else if (profileDetails?.transient) {
            console.log('anonymous user...')
        }
        var searchParam = window.location.search
        var uri = searchParam.split("?")

        if (profileDetails && profileDetails.transient && uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
            history.push("/account/login?resume=prev")
        }
    }, [profileDetails])

    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in orderHistory page loader true");
        } else {
            console.log("log in orderHistory page loader false");
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/order/order-history-list`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setOrderHitstoryList((JSON.parse(res.response)).response)
                        const totalCountObj = orderHitstoryListRef.current.find(obj => obj.totalCount !== undefined);
                        const totalCount = totalCountObj ? totalCountObj.totalCount : "";
                        setItemTotalCount(totalCount.toString())
                        const completeOrderHistoryMap = orderHitstoryListRef.current.find(obj => obj.userDetailsMap !== undefined);
                        // const profileId = completeOrderHistoryObj ? completeOrderHistoryObj.profileId : ""; 
                        setProfileId(completeOrderHistoryMap && completeOrderHistoryMap.userDetailsMap && completeOrderHistoryMap.userDetailsMap.profileId ? completeOrderHistoryMap.userDetailsMap.profileId : '');
                        setShowCompleteOrderHistory(completeOrderHistoryMap?.userDetailsMap?.completeOrderHistory ? completeOrderHistoryMap?.userDetailsMap?.completeOrderHistory : false)
                        if(userTypeRef.current == 2) {
                            generateCompleteOrderHistoryURL();
                        } else if(itemTotalCountRef.current > 0) {
                            generateCompleteOrderHistoryURL();
                        }

                    } else {
                        const error = res.result;

                    }
                })
        }
    }, [])

    function modifyState() {
        let stateObj = { id: "100" };
        window.history.replaceState(stateObj,
            "showCart", "?showCart=true&event=cart_updated");
    }

    async function handleReorder(event) {
        event.preventDefault();
        const reorderOrderId = event.currentTarget.getAttribute("orderIdState")
        const index = event.currentTarget.getAttribute("index")
        setOrderItemId(reorderOrderId)

        var actionUrl = "api/rest/cb/order/reorder";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            reorderOrderId: reorderOrderId
        }))
        if (res.result == "success") {
            var response = (JSON.parse(res.response))?.response
            const isCartModalFlagObj = response?.find(obj => obj.isCartModalFlag !== undefined);
            const isCartEmptyFlag = isCartModalFlagObj ? isCartModalFlagObj.isCartModalFlag : "";
            const messageObj = (JSON.parse(res.response))?.errorMessage
            if (isCartEmptyFlag === false) {
                setCartModal(true)
                var modalElement = document.getElementById(`recorderModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
            } else if (Array.isArray(messageObj)) {
                const messages = messageObj.map(error => error.message).join('<br/>');
                dispatch(updateProfileDetailsAction(true, "cart"))
                setErrorMsg(messages)
            }
            else {
                modifyState()
                dispatch(updateProfileDetailsAction(true, "cart"))
                setCartUpdatedModal(true)
                var modalElement = document.getElementById(`addProductToCartModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
                const itemCheck = JSON.parse(res?.response);
                setOderItemDetail(itemCheck?.response[0]);
                handleSiteSpecDataLayer(orderItemDetailRef.current?.response?.validproducts)

            }
        }
        else {
            console.log("errorList-----", res)
        }

    }


    function handleSiteSpecDataLayer(validateProduct) {
        let productList = []
        {
            validateProduct?.map((oneProduct) => {
                let categoryList = [];
                let category = oneProduct?.dataLayer_obj
                const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

                categoryList = categoryList1;
                const productMapDuplicate = {
                    "productId": oneProduct.ProductId,
                    "category": categoryList
                }
                let productMap = productMapDuplicate;
                productList.push(productMap)
            })
        }

        const page = {
            "type": "product",
            "products": productList
        }
        const ORDERHISTORY_payload = {
            "page": page
        }
        window.ssRecsInfo = window.ssRecsInfo || {}
        window.ssRecsInfo = ORDERHISTORY_payload
        window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': ORDERHISTORY_payload}))
        
    }
    async function handleKeepExistingItem(event) {
        event.preventDefault();
        const reorderOrderId = orderItemIdRef.current;
        const action = event.currentTarget.getAttribute("action")
        const index = event.currentTarget.getAttribute("index")
        var actionUrl = "api/rest/cb/order/reorder-from-modal";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            reorderOrderId: orderItemIdRef.current,
            action: action
        }))
        if (res.result == "success") {
            const messageObj = (JSON.parse(res.response))?.errorMessage

            if (Array.isArray(messageObj)) {
                const messages = messageObj.map(error => error.message).join('<br/>');
                document.getElementById(`recorderModal-close${index}`).click()
                dispatch(updateProfileDetailsAction(true, "cart"))
                setErrorMsg(messages)
            } else {
                modifyState()
                document.getElementById(`recorderModal-close${index}`).click()
                setCartUpdatedModal(true)
                var modalElement = document.getElementById(`addProductToCartModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
                dispatch(updateProfileDetailsAction(true, "cart"))
                setOderItemDetail((JSON.parse(res.response))?.response)
                handleSiteSpecDataLayer(orderItemDetailRef.current?.response?.validproducts)
            }
        }
        else {
            console.log("errorList-----", res)
        }
    }
    function paginationState() {
        var resultPerPage = resultPerPageRef.current;
        var page = String(currentPageCountRef.current);
        var total = itemTotalCountRef.current;
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/order/order-history-pagination/${resultPerPage}/${page}/${total}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setPaginationNumber((JSON.parse(res.response)).response)
                } else {
                }
            })
    }
    useEffect(() => {
        if (itemTotalCountRef.current != '') {
            paginationState()
        }
    }, [itemTotalCountRef.current])

    async function handlePagination(event) {
        event.preventDefault();
        var index = event.currentTarget.getAttribute("index")

        if (index != null) {
            var pageCount = document.getElementById(`paginationId${index}`).getAttribute("item")

            var newPageCount;
            if (pageCount === "« Previous") {
                newPageCount = String(currentPageCountRef.current - 1);
                setCurrentPageCount(parseInt(newPageCount))
            } else if (pageCount === "Next »") {
                newPageCount = String(currentPageCountRef.current + 1);
                setCurrentPageCount(parseInt(newPageCount))
            } else {
                newPageCount = pageCount;
                setCurrentPageCount(parseInt(newPageCount))
            }

        }

        await handleSortItemClick(event);
        paginationState()
    }

    async function handleSortItemClick(event) {
        event.preventDefault();
        const sortName = event.currentTarget.getAttribute("sortName")
        if (sortName == "jdeOrderNumber" || sortName == "submittedDate") {
            setItemSortName(sortName)
        } else {
            setItemSortName(itemSortNameRef.current)
        }

        var actionUrl = "api/rest/cb/order/order-history-sort-list";
        var sort = itemSortNameRef.current;
        var accend = String(sortFlagRef.current);
        var page = String(currentPageCountRef.current);
        var numPerPage = resultPerPageRef.current;
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/${sort}/${accend}/${page}/${numPerPage}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, "", "")
        if (res.result == "success") {
            setOrderHitstoryList((JSON.parse(res.response)).response)
        }
        else {
            console.log("errorList-----", res)
        }
    }

    async function handleSortItemJde(event) {
        event.preventDefault();
        const sortName = event.currentTarget.getAttribute("sortName")
        var sortWebNumber = document.getElementById("sortWebNumber");
        var sortOrderDate = document.getElementById("sortOrderDate");
        if (sortName == "jdeOrderNumber") {
            setItemSortName(sortName)
        } else {
            setItemSortName(itemSortNameRef.current)
        }
        setJdeOrderNumberFlag(!jdeOrderNumberRef.current)
        setSortFlag(jdeOrderNumberRef.current)
        if (sortOrderDate) {
            sortOrderDate.classList.remove("sort-down")
            sortOrderDate.classList.remove("sort-up")
        }
        if (jdeOrderNumberRef.current == true && sortName == "jdeOrderNumber") {
            sortWebNumber.classList.add("sort-up")
            sortWebNumber.classList.remove("sort-down")
        } else if (jdeOrderNumberRef.current == false && sortName == "jdeOrderNumber") {
            sortWebNumber.classList.add("sort-down")
            sortWebNumber.classList.remove("sort-up")
        } else {
            sortWebNumber.classList.remove("sort-down")
            sortWebNumber.classList.remove("sort-up")

        }
        var actionUrl = "api/rest/cb/order/order-history-sort-list";
        var sort = itemSortNameRef.current;
        var accend = String(jdeOrderNumberRef.current);
        var page = String(currentPageCountRef.current);
        var numPerPage = resultPerPageRef.current;
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/${sort}/${accend}/${page}/${numPerPage}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, "", "")
        if (res.result == "success") {
            setOrderHitstoryList((JSON.parse(res.response)).response)
        }
        else {
            console.log("errorList-----", res)
        }
    }

    async function handleSortItemDate(event) {
        event.preventDefault();
        const sortName = event.currentTarget.getAttribute("sortName")
        var sortWebNumber = document.getElementById("sortWebNumber");
        var sortOrderDate = document.getElementById("sortOrderDate");
        if (sortName == "submittedDate") {
            setItemSortName(sortName)
        } else {
            setItemSortName(itemSortNameRef.current)
        }
        setSubmittedDateFlag(!submittedDateRef.current)
        setSortFlag(submittedDateRef.current)
        if (sortWebNumber) {
            sortWebNumber.classList.remove("sort-down")
            sortWebNumber.classList.remove("sort-up")
        }
        if (submittedDateRef.current == true && sortName == "submittedDate") {
            sortOrderDate.classList.add("sort-up")
            sortOrderDate.classList.remove("sort-down")
        } else if (submittedDateRef.current == false && sortName == "submittedDate") {
            sortOrderDate.classList.add("sort-down")
            sortOrderDate.classList.remove("sort-up")
        } else {
            sortOrderDate.classList.remove("sort-down")
            sortOrderDate.classList.remove("sort-up")
        }
        var actionUrl = "api/rest/cb/order/order-history-sort-list";
        var sort = itemSortNameRef.current;
        var accend = String(submittedDateRef.current);
        setSortFlag(accend)
        var page = String(currentPageCountRef.current);
        var numPerPage = resultPerPageRef.current;
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/${sort}/${accend}/${page}/${numPerPage}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, "", "")
        if (res.result == "success") {
            setOrderHitstoryList((JSON.parse(res.response)).response)
        }
        else {
            console.log("errorList-----", res)
        }
    }

    async function handleResultPerPage(event) {
        const value = document.getElementById("numPerPage").value
        setResultPerPage(value)
        await handlePagination(event);
    }

    const breadCrumbs = {
        "ancestors": [{
            label: "My Account",
            link: "/account/landing"
        }],
        productName: "Order History"
    };

    function handlePrintPage() {
        window.print()
    }

    // useEffect(()=>{
    //     if(currentAddressIdRef.current){
    //         console.log('currentAddressIdRef.current...inside useEffect..',currentAddressIdRef.current);
    //         generateCompleteOrderHistoryURL();
    //     }
    // },[currentAddressIdRef.current])

    async function generateCompleteOrderHistoryURL() {
        var actionUrl = 'api/rest/cb/order/complete-order-history-url'
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}?userId=${profileIdRef.current}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, '');

        if (res.result == "success") {
            var response = (JSON.parse(res.response)).response
            const completeOrderHistory = response['ordersPlusLink'];
            setOrderPlusLinkMsg(response['linkMessage']);
            { completeOrderHistory && setCompleteOrderHistoryUrl(completeOrderHistory); }
        } else {
            console.log('res.response...', res.response);

        }
    }
    function handleOnClickCompleteOrderHistory(event) {
        event.preventDefault();
        if (completeOrderHistoryUrlRef.current) {
            document.getElementById('hidden-url-button').click();
        }
    }
    // useEffect(() => {
    //     var searchParam = window.location.search
    //     var uri = searchParam.split("?")

    //     if (profileDetails && profileDetails.transient && uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
    //         history.push("/account/login?resume=prev")
    //     }
    // }, [profileDetails])

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            {profileDetails && !profileDetails.transient ?
                <>
                    <div className="row align-items-center cb-breadcrum-list gx-0">
                        <div className="col-md-11 header-padding-row">
                            <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="OrderHistory" />
                        </div>

                        <div className="col-12 col-md-1 header-padding-row d-none d-lg-block">
                            <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                                <i className="fas fa-print" ></i>Print
                            </button>
                        </div>

                    </div>
                    <div id="add-item-error-message" className={`message message-red ${errorMsgRef.current ? 'd-block' : 'd-none'}`}>
                        <p dangerouslySetInnerHTML={{ __html: errorMsgRef.current }}></p>
                    </div>
                    <div className="row page-min-height gx-0 c-shopping-list-item-padding">
                        <MyAccountCommonize />

                        <div id="content" className="col-lg-9 c-shopping-list-item-col c-my-profile-details">
                            <div className='row my-3 my-md-0'>
                                <div className='col-8 col-md-8'>
                                    <div className="d-md-flex align-items-center">
                                        <h1 className="c-account-list-heading me-3">Online Order History</h1>
                                        <div id="ordersPlusLinkTop">
                                            {userTypeRef.current == 2 || itemTotalCountRef.current > 0 ? <>
                                                {completeOrderHistoryUrlRef.current ?
                                                    <Link target="_blank">
                                                        <button onClick={handleOnClickCompleteOrderHistory}
                                                            className="btn btn-primary">{orderPlusLinkMsgRef.current ? orderPlusLinkMsgRef.current : ''}
                                                        </button>
                                                    </Link>
                                                    : `${orderPlusLinkMsgRef.current ? orderPlusLinkMsgRef.current : ''}`}
                                            </> : <></>}

                                            <a id='hidden-url-button' type='hidden' target='_blank' href={completeOrderHistoryUrlRef.current ? completeOrderHistoryUrlRef.current : ''}></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-4 d-lg-none">
                                    <CbMobileLogOut />
                                </div>
                            </div>

                            <div className="c-list-bar mt-3">
                                <div className="col-12 col-md-6 d-none d-lg-block" id="pagination">
                                    <nav aria-label="Page navigation example">
                                        {itemTotalCountRef.current > 12 &&
                                            <ul className="c-pagination pagination justify-content-start pagination-lg">
                                                {paginationNumberRef.current && paginationNumberRef.current.map((item, index) => {
                                                    return (<>
                                                        <li className="page-item" >
                                                            <Link className={`${item !== '...' ? 'page-link' : 'pe-none'}`} onClick={handlePagination} id={`paginationId${index}`} index={index} item={item} >
                                                                {item}
                                                            </Link>
                                                        </li>
                                                    </>
                                                    )
                                                })}
                                            </ul>
                                        }
                                    </nav>
                                </div>
                                <div className="c-listbar-right d-flex">
                                    <div className="col-12 col-md-12">
                                        <div className="perpage-view">
                                            <select className="form-select form-select-sm cb-select-perpage" onChange={handleResultPerPage} id="numPerPage">
                                                <option value="12">12</option>
                                                <option value="24">24</option>
                                                <option value="48">48</option>
                                                <option value="60">60</option>
                                            </select>
                                            <label for="example" className="form-label d-lg-block d-none">Per page</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='c-list-table c-order-history'>
                                        <ul className="c-shop-list mt-0">
                                            <li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                <div className="c-list-left">
                                                    <span className="c-shop-list-content">Order # <Link className="sort" onClick={handleSortItemJde} id="sortWebNumber" sortName="jdeOrderNumber">Sort</Link></span>
                                                    <span className="c-shop-list-content">Date <Link className="sort" onClick={handleSortItemDate} id="sortOrderDate" sortName="submittedDate">Sort</Link></span>
                                                    <span className="c-shop-list-content">Total</span>
                                                    <span className="c-shop-list-content">Status </span>
                                                    <span className="c-shop-list-content"># Items</span>
                                                </div>
                                                <div className="c-list-right">
                                                    <span></span>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul className="c-shop-list mb-0" id="order-list">
                                            {orderHitstoryListRef.current && Object.entries(orderHitstoryListRef.current).map(([key, historyList], index) => {
                                                const formattedPrice = historyList.total !== undefined ? historyList.total.toLocaleString({ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "";
                                                return (<>
                                                    {historyList && historyList.total ?
                                                        <li className="c-shop-list-item c-shop-list-body" key={index}>
                                                            <div className="c-list-left">
                                                                <span className="c-shop-list-content c-mobile-order-value">
                                                                    <span className="d-block d-md-none c-shop-mobile-label">Order#</span>
                                                                    <Link to={`/account/order-detail?orderId=${historyList.orderId}&userId=${historyList.profileId}`} className="fw-bold">{historyList.webOrderId}</Link>
                                                                </span>
                                                                <span className="c-shop-list-content c-mobile-order">
                                                                    <span className="d-block d-md-none c-shop-mobile-label">Date: </span>
                                                                    {historyList.createdDate}
                                                                </span>
                                                                <span className="c-shop-list-content c-mobile-order">
                                                                    <span className="d-block d-md-none c-shop-mobile-label"><strong>Total: </strong></span>
                                                                    <strong>{historyList && historyList.total !== undefined ? formattedPrice : ""}</strong>
                                                                </span>
                                                                <span className="c-shop-list-content c-mobile-order">
                                                                    <span className="d-block d-md-none c-shop-mobile-label"><strong>Status: </strong></span>
                                                                    <strong>
                                                                        {historyList.status}
                                                                    </strong>
                                                                </span>
                                                                <span className="c-shop-list-content c-mobile-order">
                                                                    <span className="d-block d-md-none c-shop-mobile-label">Items:</span>
                                                                    {historyList.quantity}
                                                                </span>
                                                            </div>
                                                            <div className="c-list-right text-end" >
                                                                <form method="POST" name="reorderFormo669970435" action="/account/order" id="reorderFormo669970435">
                                                                </form>
                                                                <button type="button" onClick={handleReorder} index={index} orderIdState={historyList.orderId} id='orderIdState' className="btn c-shop-btn c-list-btn-action c-list-btn-items-mobile" >
                                                                    Reorder
                                                                </button>
                                                                <Link to={`/account/order-detail?orderId=${historyList.orderId}&userId=${historyList.profileId}`} className="btn c-shop-btn c-list-btn-action">View Details</Link>
                                                            </div>
                                                        </li>
                                                        : ""}

                                                    {cartModal ?
                                                        <div className="modal fade gx-0 c-shopping-list-modal-body" id={`recorderModal${index}`}
                                                            tabindex="-1" aria-labelledby={`recorderModal${index}`} aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                                                                <div className="modal-content">
                                                                    <button type="button" className="btn-close" id={`recorderModal-close${index}`} data-bs-dismiss="modal" aria-label="Close"></button>
                                                                    <div className="modal-body">
                                                                        {/* <form method="post" action="/" id="find-friend" className="col-12 form" data-hs-cf-bound="true"> */}
                                                                        <div className="container-fluid list-modal-body">
                                                                            <div className="row mb-4">
                                                                                <div className="col-12">
                                                                                    <h3 className="modal-title mb-3" id="defaultModalLabel">Add to Cart</h3>
                                                                                    <p className="modal-subheading">You currently have items in your cart. Would you like to <strong>keep those items</strong> or <strong>replace your current cart</strong>?</p>
                                                                                </div>
                                                                                <div className="col-12 text-center">
                                                                                    <button type="button" className="btn btn-primary me-2" onClick={handleKeepExistingItem} index={index} action='keep'>Keep Existing Items</button>
                                                                                    <button type="button" className="btn btn-primary" onClick={handleKeepExistingItem} index={index} action='clearCart'>Replace Items</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/* </form> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ""}

                                                    {cartUpdatedModal &&
                                                        <Modal index={index} giftlistId={`giftlistId${index}`} props={orderItemDetailRef.current?.response?.validproducts} invalidProduct={orderItemDetailRef.current?.response?.invalidProducts} />
                                                    }

                                                </>
                                                )
                                            })}

                                        </ul>
                                    </div>
                                </div>


                            </div>

                           {userTypeRef.current == 2 || itemTotalCountRef.current > 0 ?
                               <div className="row my-3 my-md-5 c-order-history-content">
                                   <div className="col-12 col-md-12">
                                       <h1 className="c-account-list-heading">Complete Order History</h1>
                                       <p className="my-2"></p>
                                       <p>Access you organization's complete online and offline order history. View all invoice and payment history.<br /> All of your voucher history is summarized for you. You can also pay your open invoices online.<br /> Please contact customer service by phone, email or chat to enable online invoice payments. </p>
                                       <p></p>
                                   </div>
                                   <div className="row align-items-center c-shopping-list-item-col">
                                       <div className="col-12 col-md-12 text-md-end px-4" id="ordersPlusLink">
                                           {completeOrderHistoryUrlRef.current && showCompleteOrderHistoryRef.current ? <Link target="_blank"> <button onClick={handleOnClickCompleteOrderHistory} className="btn btn-primary">{orderPlusLinkMsgRef.current ? orderPlusLinkMsgRef.current : ''}</button></Link> : `${orderPlusLinkMsgRef.current ? orderPlusLinkMsgRef.current : ''}`}
                                           {/* {completeOrderHistoryUrlRef.current ? <Link target="_blank"> <button onClick={handleOnClickCompleteOrderHistory} className="btn btn-primary">Complete Order History</button></Link> : 'Complete Order History Link is empty'} */}
                                       </div>
                                   </div>
                               </div> : ''
                           }
                        </div>
                    </div>
                </> : ""}
        </div >
    );
}

export default OrderHistory;
